import * as React from 'react'
import { AppError } from '../services/errorHandlingService'
import { Toast } from '../../components/ui/EnhancedToast'

export const ToastContext = React.createContext<{
  showToast: (toast: Omit<Toast, 'id'>) => void
  showError: (error: AppError) => void
  showSuccess: (title: string, message?: string) => void
  showWarning: (title: string, message?: string) => void
  showInfo: (title: string, message?: string) => void
  dismissToast: (id: string) => void
}>({
  showToast: () => {},
  showError: () => {},
  showSuccess: () => {},
  showWarning: () => {},
  showInfo: () => {},
  dismissToast: () => {}
})
